import { RequestLanguage, RequestType } from "../../../../../constants";

export const useECRequests = () => {
  const requests = [
    {
      id: "1",
      createdDateTime: "17/08/2023",
      createdByName: "Canbo1",
      requestType: RequestType.confirm,
      requestLanguage: RequestLanguage.vi,
      requestStatus: "Đang đợi duyệt",
    },
    {
      id: "2",
      createdDateTime: "12/08/2023",
      createdByName: "Canbo2",
      requestType: RequestType.confirm,
      requestLanguage: RequestLanguage.vi,
      requestStatus: "Đang đợi duyệt",
    },
    {
      id: "3",
      createdDateTime: "17/08/2023",
      createdByName: "Canbo1",
      requestType: RequestType.confirm,
      requestLanguage: RequestLanguage.en,
      requestStatus: "Đang đợi duyệt",
    },
    {
      id: "4",
      createdDateTime: "14/08/2023",
      createdByName: "Canbo3",
      requestType: RequestType.confirm,
      requestLanguage: RequestLanguage.vi,
      requestStatus: "Đang đợi duyệt",
    },
    {
      id: "5",
      createdDateTime: "17/08/2023",
      createdByName: "Canbo5",
      requestType: RequestType.confirm,
      requestLanguage: RequestLanguage.en,
      requestStatus: "Đang đợi duyệt",
    },
  ];

  return { requests, myRequests: requests };
};
